import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import {Container, Box, CircularProgress, Paper, Typography} from "@mui/material";


function ConfirmEmail(){

    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState({
        loading: true,
        title: "",
        description: ""
    });

    useEffect(function() {
        const emailString = searchParams.get("e");

        if (emailString && emailString.length > 5) {
            // Logic for actual processing
//            processNewsletterConfirmEmailAddress(emailString);

            setStatus({
                loading: false,
                title: "Processing Confirmation",
                description: "One moment while we verify your email..."
            });
        } else {
            // Logic for the 'missing email' fallback
            setStatus({
                loading: false,
                title: "We hope you are having a wonderful day!",
                description: "Please check your email inbox for a link you can click on to complete the confirmation process."
            });
        }
    }, [searchParams]);

    // View: Using MUI components for layout
    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 10, textAlign: 'center' }}>
                <Paper elevation={2} sx={{ p: 4 }}>
                    {status.loading ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography variant="h5" color="primary" gutterBottom>
                                {status.title}
                            </Typography>
                            <Typography variant="body1">
                                {status.description}
                            </Typography>
                        </>
                    )}
                </Paper>
            </Box>
        </Container>
    );
}

export default ConfirmEmail;


